import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { ForgotPassword } from '@/features/auth/components/templates/forgot-password/forgot-password';

const forgotPasswordSearchSchema = z.object({
  expired: fallback(z.boolean(), false).default(false),
});

export const Route = createFileRoute('/(auth)/forgot-password')({
  component: ForgotPassword,
  validateSearch: zodValidator(forgotPasswordSearchSchema),
});
